import React, { useEffect } from "react";
import "./KYC.scss";
import Select from "react-select";
import StatisticTable from "../../../../components/StatisticTable/StatisticTable";
import {
  customStylesSelect,
  loaderOverride,
  totalsRanges,
} from "../../../../utils/constants/constants";
import TotalRangePicker from "../../../../components/TotalRangePicker/TotalRangePicker";
import useTableContent from "./hooks/useTableContent";
import { MoonLoader } from "react-spinners";
import useKYC from "./hooks/useKYC";
import KYCLegend from "../../../../components/KYCLegend/KYCLegend";
import KYCItem from "../../../../components/KYCItem/KYCItem";

const KYC = () => {
  const {
    filterTypeSaved,
    fromSaved,
    toSaved,
    fromDate,
    toDate,
    isLoaded,
    selectorValue,
    isLoading,
    data,
    showRangePicker,
    setSelectorValue,
    getKYCData,
    setIsLoaded,
    setShowRangePicker,
    getDateRange,
    setFromDate,
    setToDate,
  } = useKYC();
  const { pendingTable, passedTable, totalTable } = useTableContent(data);

  useEffect(() => {
    if (filterTypeSaved && filterTypeSaved !== "null") {
      setSelectorValue(filterTypeSaved);
      getKYCData(fromSaved, toSaved);
    } else if (filterTypeSaved === "null" && fromSaved) {
      setSelectorValue("customized");
      getKYCData(fromSaved, toSaved);
    } else {
      getKYCData(fromDate, toDate);
    }
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (isLoaded) {
      if (selectorValue === "customized") {
        setSelectorValue("customized");
        return setShowRangePicker(true);
      }

      if (selectorValue) {
        const range = getDateRange(selectorValue);
        getKYCData(range.startDate, range.endDate);
      }
    }
  }, [selectorValue]);

  if (isLoading) {
    return (
      <div className="kyc__loader">
        <MoonLoader
          color="#7236CD"
          loading={isLoading}
          cssOverride={loaderOverride}
          size={35}
        />
      </div>
    );
  }
  return (
    <div className="kyc__wrapper">
      <div className="kyc__tables">
        <StatisticTable data={totalTable} />
        <StatisticTable data={pendingTable} />
        <StatisticTable data={passedTable} />
      </div>
      <div className="kyc__selector-wrapper">
        <span className="kyc__selector-label">Period</span>
        <Select
          styles={customStylesSelect}
          options={totalsRanges}
          placeholder={"placeholder"}
          getOptionValue={(option) => option.value}
          onChange={(option) => {
            if (
              option.value === "customized" &&
              selectorValue === "customized"
            ) {
              setShowRangePicker(true);
            }

            setSelectorValue(option.value);
          }}
          value={totalsRanges.find((option) => option.value === selectorValue)}
        />
      </div>
      <div className="kyc__items-table">
        <KYCLegend />
        {data?.grouped
          ? Object.entries(data?.grouped)
              ?.reverse()
              ?.map((el) => <KYCItem el={el} key={el[0]} />)
          : null}
      </div>
      {showRangePicker && (
        <TotalRangePicker
          showModal={showRangePicker}
          setShowModal={setShowRangePicker}
          getData={getKYCData}
          setFromDate={setFromDate}
          setToDate={setToDate}
          fromDate={fromDate}
          toDate={toDate}
        />
      )}
    </div>
  );
};

export default KYC;
